import processLocale from "@lib/locale"
import listConfig from "../api/config"


export const getListConfig = (locale: string) => {
  const { listConfig: { context } } = listConfig
  const currentLocale = processLocale(locale)
  const currentContext = context?.[currentLocale]
  return currentContext
}